/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_OnlineInputs */

const vi_grower_area_camera_online = /** @type {(inputs: Grower_Area_Camera_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang phát`)
};

/**

* @param {Grower_Area_Camera_OnlineInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_online = /** @type {((inputs?: Grower_Area_Camera_OnlineInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_OnlineInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_online(inputs)
});